export function DestroyPlugin() {
  const tomSelect = this

  // Default destroy will reset the input to the original DOM elements present at the time of initialization - Matt, Stephen, Wed Jan 7 2026
  tomSelect.hook("instead", "destroy", () => {
    tomSelect.trigger("destroy")
    tomSelect.off()
    tomSelect.wrapper.remove()
    tomSelect.dropdown.remove()

    tomSelect.input.classList.remove("tomselected")
    tomSelect.input.classList.remove("ts-hidden-accessible")

    tomSelect.input.tabIndex = tomSelect.revertSettings.tabIndex

    tomSelect._destroy()

    delete tomSelect.input.tomselect
  })
}
